import type { Debt } from '@/types'

/**
 * Anonymous-mode initial state.
 *
 * Empty by design. Every device that lands on the app sees a friendly
 * "Welcome to DebtOS" empty state with two affordances:
 *   1. Add your first debt — for new users starting fresh
 *   2. Sign in — for returning users with cloud-synced data
 *
 * No demo/example data is shown. Previously this seeded the founder's
 * actual portfolio (~$700K of personal financial detail) into every
 * unauthenticated visitor's localStorage; v0.8.1 retired that pattern.
 * A fictional demo seed lived here briefly in between but was removed —
 * an empty state communicates "this is your space, not someone else's"
 * more cleanly than placeholder data ever can.
 *
 * Signed-in users never reach this code path; their cloud data replaces
 * the local repo via `bindReposToSession`.
 */

export const SEED_DEBTS: Debt[] = []

export const SEED_STATIC_DEBTS: Debt[] = []
